module.exports = __webpack_public_path__ + "img/gotfertomi-coussins-3.82d83052.jpg";